var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtUser04Heart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#ECFDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4208 18.133C23.2292 17.9036 22.9909 17.7144 22.7205 17.5768C22.4501 17.4393 22.1533 17.3564 21.8484 17.3332C21.391 17.3043 20.9357 17.4138 20.5462 17.6465C20.1575 17.4121 19.7016 17.3024 19.244 17.3332C18.9396 17.3556 18.6432 17.4374 18.3728 17.5738C18.1025 17.7102 17.8639 17.8982 17.6716 18.1263C17.2767 18.6154 17.0711 19.2215 17.0901 19.8405C17.109 20.4596 17.3514 21.053 17.7755 21.5188L19.7219 23.6316C19.8253 23.7471 19.9534 23.8399 20.0975 23.9035C20.2415 23.967 20.3981 23.9999 20.5566 23.9999C20.7151 23.9999 20.8717 23.967 21.0157 23.9035C21.1598 23.8399 21.2879 23.7471 21.3913 23.6316L23.3169 21.5188C23.7393 21.0534 23.9805 20.4614 23.9995 19.8438C24.0184 19.2262 23.8139 18.6215 23.4208 18.133Z",
    fill: "#0BA5EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6197 15.3339C16.2975 15.3339 18.4684 13.2451 18.4684 10.6684C18.4684 8.09173 16.2975 6.00293 13.6197 6.00293C10.9418 6.00293 8.771 8.09173 8.771 10.6684C8.771 13.2451 10.9418 15.3339 13.6197 15.3339Z",
    fill: "#0BA5EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7295 22.4056L18.2049 23.9985H8.07804C7.52692 23.9985 6.99837 23.7879 6.60866 23.4129C6.21896 23.0379 6.00003 22.5294 6.00003 21.9991V21.3326C5.99651 20.1084 6.3116 18.9029 6.91656 17.8261C7.52152 16.7492 8.39709 15.8352 9.46338 15.1675C10.6019 16.1328 12.0673 16.6654 13.5848 16.6654C15.1022 16.6654 16.5676 16.1328 17.7062 15.1675C18.1249 15.406 18.5171 15.6852 18.8768 16.0006C17.9855 16.1318 17.1762 16.5758 16.6048 17.2469C15.9812 17.9791 15.6508 18.9021 15.6737 19.8485C15.6966 20.7949 16.0712 21.7021 16.7295 22.4056Z",
    fill: "#0BA5EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtUser04Heart);
export default __webpack_public_path__ + "static/media/at_user-04-heart.49be188dba0b94cd0d25db79a07e7214.svg";
export { ForwardRef as ReactComponent };